<template>
  <div class="w-full justify-start items-center p-1" v-if="loaded" @click.stop>
    <div class="w-full flex">
      <v-select label="id" :filterable="false" :options="listProducts" @search="onSearch" v-model="selectedProduct" :reduce="product_ => product_.id"
                class="w-full" @input="changeProduct" v-bind="$attrs">
        <template #no-options>
          {{ $t('components.chooseCategory.notFindProduct') }}
        </template>

        <template #option="option">
          <div class="flex items-center">
            <vs-avatar :src="option.image" :text="option.code"/>
            {{ option.code }} - {{ dataLang(option).name }}
          </div>
        </template>

        <template #selected-option="option">
          <div class="flex items-center">
            <vs-avatar :src="option.image" :text="option.code"/>
            {{ option.code }} - {{ dataLang(option).name }}
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import {showErrorNotify} from "@/helpers/functionsHelpers";
import ProductService from "@/services/Product.service";
import {Product} from "@/models/Product.model";

export default {
  name: "ChooseProduct",
  inheritAttrs: false,
  props: {
    value: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      products: [],
      selectedProduct: null,

      queryString: null,
      loaded: false
    };
  },
  watch: {
    value() {
      this.lookupProduct();
    }
  },
  computed: {
    listProducts() {
      return this.products;
    }
  },
  methods: {
    lookupProduct() {
      return this.$store.dispatch('Products/lookupProduct', this.value).then((response) => {
        this.selectedProduct = response;
        return Promise.resolve(response);
      }, error => {
        showErrorNotify(this, error);
        return Promise.reject();
      });
    },
    dataLang(product) {
      const locale = this.$i18n.locale;
      return product[locale];
    },
    onSearch(search, loading) {
      this.queryString = search;
      loading(true);
      this._.debounce((loading, search, vm) => {
        if (!search || search.empty) {
          loading(false);
          return;
        }
        //User keep typing...
        if (search !== vm.queryString) {
          return;
        }

        ProductService.queryProduct(search).then((response) => {
          vm.products = [];
          response.forEach(u => {
            vm.products.push(Product.FromObj(u));
          });
          loading(false);
          this.queryString = null;
        }, error => {
          loading(false);
          showErrorNotify(vm, error);
        })
      }, 500)(loading, search, this);
    },
    changeProduct(newVal) {
      let new_product_value = newVal || 0;
      this.$emit('input', new_product_value);
    }
  },
  created() {
    this.loaded = false;
  },
  mounted() {
    this.lookupProduct().then(() => {
      this.loaded = true;
    });
  }
}
</script>

<style scoped>

</style>
